import React from "react"
import { useScrollReveal, trackStyles, deriveIndicators } from "../utils"

function KirkpatrickView({ measurement }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 60px" }}>
      {measurement.levels.map((lvl, li) => (
        <div key={li} style={{ paddingTop: 32 }}>
          {/* Level header */}
          <div style={{
            paddingBottom: 20,
            borderBottom: "1px solid rgba(255,255,255,0.12)",
          }}>
            <span style={{
              fontSize: 11, fontWeight: 700, letterSpacing: "0.08em",
              color: "#FF4000", display: "block", marginBottom: 8,
            }}>
              Level {lvl.level}
            </span>
            <span style={{
              fontFamily: "Instrument Serif, Georgia, serif",
              fontSize: "clamp(28px, 3vw, 48px)", fontWeight: 400,
              letterSpacing: "-0.02em", color: "#fff", lineHeight: 1.05,
              display: "block",
            }}>
              {lvl.name}
            </span>
          </div>

          {/* Indicators */}
          {lvl.indicators.map((ind, ii) => (
            <div key={ii} style={{
              padding: "16px 0",
              borderBottom: "1px solid rgba(255,255,255,0.07)",
            }}>
              <span style={{ fontSize: 15, fontWeight: 500, color: "#fff", lineHeight: 1.4, display: "block", marginBottom: 4 }}>
                {ind.label}
              </span>
              <span style={{ fontSize: 13, lineHeight: 1.6, color: "#fff" }}>
                {ind.how}
              </span>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

function FlatView({ measurement, styleMap }) {
  const indicators = deriveIndicators(measurement, styleMap)
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
      {indicators.map((ind, i) => {
        const ts = trackStyles[ind.styleKey]
        const isFilled = ind.styleKey === "mentor"
        return (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 24, padding: "20px 0", borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
            <div style={{
              width: 8, height: 8, borderRadius: "50%", flexShrink: 0, marginTop: 6,
              background: isFilled ? ts.color : "transparent",
              border: isFilled ? "none" : `1.5px ${ts.borderStyle} ${ts.color}`,
              opacity: ts.opacity,
            }} />
            <div>
              <span style={{ fontSize: 15, fontWeight: 600, color: "#fff", display: "block", marginBottom: 4 }}>{ind.label}</span>
              <span style={{ fontSize: 14, lineHeight: 1.5, color: "#fff" }}>{ind.desc}</span>
            </div>
          </div>
        )
      })}
    </div>
  )
}

function linkifyKirkpatrick(text) {
  const parts = text.split("Kirkpatrick model")
  if (parts.length === 1) return text
  return (
    <>
      {parts[0]}
      <a
        href="https://www.kirkpatrickpartners.com/the-kirkpatrick-model/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#fff", textDecoration: "underline", textUnderlineOffset: 3 }}
      >
        Kirkpatrick model
      </a>
      {parts[1]}
    </>
  )
}

export function MeasurementBlock({ programme, styleMap }) {
  const ref = useScrollReveal()
  const m = programme.measurement
  const isKirkpatrick = Array.isArray(m?.levels)

  return (
    <div ref={ref} style={{ padding: "80px 60px 100px", boxSizing: "border-box" }}>
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.12)", paddingTop: 60 }}>
        <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", margin: "0 0 28px", color: "#fff" }}>
          How we measure success
        </p>
        {m?.description && (
          <p style={{ fontSize: 16, lineHeight: 1.7, maxWidth: 600, margin: "0 0 8px", color: "#fff" }}>
            {isKirkpatrick ? linkifyKirkpatrick(m.description) : m.description}
          </p>
        )}
        {isKirkpatrick
          ? <KirkpatrickView measurement={m} />
          : <FlatView measurement={m} styleMap={styleMap} />
        }
      </div>
    </div>
  )
}
